import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ISiteAdmin } from '../interfaces/site-admin';
import { IAddAdmin } from '../interfaces/add-admin';
import { IUpdateAdmin } from '../interfaces/update-admin';

@Injectable({
  providedIn: 'root'
})
export class SiteAdminService {
  private rootUrl: string = "/api/site-admins";

  constructor(private httpClient: HttpClient) { }

  public getSiteAdmins(appId: number): Observable<ISiteAdmin[]> {
    const url = this.rootUrl + "?appId=" + appId;
    return this.httpClient.get<ISiteAdmin[]>(url);
  }
  
  public addSiteAdmin(appId: number, emailAppId: number, addSiteAdmin: IAddAdmin): Observable<string> {
    const url = this.rootUrl + "?appId=" + appId + "&emailAppId=" + emailAppId;
    return this.httpClient.post<string>(url, addSiteAdmin);
  }

  public addSiteAdminFromExisting(appId: number, id: string, allowLogin: boolean) {
    const url = this.rootUrl + "/from-existing?appId=" + appId + "&id=" + id + "&allowLogin=" + allowLogin;
    return this.httpClient.post(url, null);
  }

  public updateSiteAdmin(id: string, appId: number, updateSiteAdmin: IUpdateAdmin) {
    const url = this.rootUrl + "/" + id + "?appId=" + appId;
    return this.httpClient.put(url, updateSiteAdmin);
  }

  public removeSiteAdmin(appId: number, id: string) {
    const url = this.rootUrl + "/" + id + "?appId=" + appId;
    return this.httpClient.delete(url);
  }
}
